module.exports = __webpack_public_path__ + "assets/select-email-list.4be49e5f.svg";